import createIcon from '../../createIcon';

/**
 * @component @name ShapeLine
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNiAxMUM4Ljc2IDExIDExIDguNzYgMTEgNkMxMSAzLjI0IDguNzYgMSA2IDFDMy4yNCAxIDEgMy4yNCAxIDZDMSA4Ljc2IDMuMjQgMTEgNiAxMVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMSAxNEgxNkMxNC45IDE0IDE0IDE0LjkgMTQgMTZWMjFDMTQgMjIuMSAxNC45IDIzIDE2IDIzSDIxQzIyLjEgMjMgMjMgMjIuMSAyMyAyMVYxNkMyMyAxNC45IDIyLjEgMTQgMjEgMTRaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTcuNzEgNy43QzE4LjExIDcuODkgMTguNTQgOCAxOSA4QzIwLjY1IDggMjIgNi42NSAyMiA1QzIyIDMuMzUgMjAuNjUgMiAxOSAyQzE3LjM1IDIgMTYgMy4zNSAxNiA1QzE2IDUuNDYgMTYuMTEgNS44OSAxNi4zIDYuMjlMNi4yOSAxNi4zQzUuODkgMTYuMTEgNS40NiAxNiA1IDE2QzMuMzUgMTYgMiAxNy4zNSAyIDE5QzIgMjAuNjUgMy4zNSAyMiA1IDIyQzYuNjUgMjIgOCAyMC42NSA4IDE5QzggMTguNTQgNy44OSAxOC4xMSA3LjcgMTcuNzFMMTcuNzEgNy43WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ShapeLine = createIcon('ShapeLine', [
  [
    'path',
    {
      d: 'M6 11C8.76 11 11 8.76 11 6C11 3.24 8.76 1 6 1C3.24 1 1 3.24 1 6C1 8.76 3.24 11 6 11Z',
      key: '1q2l1d',
    },
  ],
  [
    'path',
    {
      d: 'M21 14H16C14.9 14 14 14.9 14 16V21C14 22.1 14.9 23 16 23H21C22.1 23 23 22.1 23 21V16C23 14.9 22.1 14 21 14Z',
      key: '1a0gfw',
    },
  ],
  [
    'path',
    {
      d: 'M17.71 7.7C18.11 7.89 18.54 8 19 8C20.65 8 22 6.65 22 5C22 3.35 20.65 2 19 2C17.35 2 16 3.35 16 5C16 5.46 16.11 5.89 16.3 6.29L6.29 16.3C5.89 16.11 5.46 16 5 16C3.35 16 2 17.35 2 19C2 20.65 3.35 22 5 22C6.65 22 8 20.65 8 19C8 18.54 7.89 18.11 7.7 17.71L17.71 7.7Z',
      key: '1l3lhg',
    },
  ],
]);

export default ShapeLine;
